import * as server from "@/utils/http"

export const _pages = params => server.get("/referral-institutiont/pages", params);

export const _get = params => server.get("/referral-institutiont/get", params);

export const _save = params => server.post(params.id ? "/referral-institutiont/update" : "/referral-institutiont/save", params);

export const _updateStatus = params => server.get("/referral-institutiont/updateStatus", params);


